// RTK Query tag types and IDs for strategy API
export const PROVIDERS_TAG_TYPES = {
  PROVIDER: 'Provider',
} as const;

export const PROVIDERS_TAG_IDS = {
  ALL_PROVIDERS: 'ALL_PROVIDERS',
  USER_PROVIDERS: 'USER_PROVIDERS',
  LIST_PROVIDERS: 'LIST_PROVIDERS',
} as const;

// Export individual constants for easier use with 'as const'
export const PROVIDERS_TAG_TYPE = 'Provider' as const;
export const ALL_PROVIDERS_ID = 'ALL_PROVIDERS' as const;
export const USER_PROVIDERS_ID = 'USER_PROVIDERS' as const;
export const LIST_PROVIDERS_ID = 'LIST_PROVIDERS' as const;
